<template>
	<div class="content">
		<div class="tableTit">
			<p class="tabtitBg"></p>
			<h6>用户管理</h6>
			<el-button class="titBtn" type="primary" icon="el-icon-plus" @click="addClick()">添加用户</el-button>
			<el-button class="titBtn" type="success" @click="resets" icon="el-icon-refresh">重置密码</el-button>

			<el-button class="titBtn" type="success" icon="el-icon-search" @click="query()">搜索</el-button>
			<!--<div style="position: relative;float: right;">
				<el-input class="querys" v-model.trim="dw" placeholder="所在部门" @focus="focusval($event)" @blur="blurval1($event)"></el-input>
				<transition name="el-zoom-in-center">
					<div v-show="khdwshow" class="rowTopa" style="top: 50px;">
						<el-tree :data="datatree" class="paddingtree" :expand-on-click-node="false" :highlight-current='true' :default-expand-all="true" :props="defaultProps" @node-click="handleNodeClick" node-key='id' ref="treeList" :default-expanded-keys='[treesid]'>
						</el-tree>
					</div>
				</transition>
			</div>-->


			<el-input class="querys" v-model.trim="username" placeholder="用户姓名"></el-input>

		</div>
		<div class="tabBody">
			<el-table :data="tabledata" @selection-change="handleSelectionChange"
       :height="tableHeight" border :header-cell-style="{background:'rgba(49,130,222,0.1)'}">
        <el-table-column type="selection" width="40" fixed="left"></el-table-column>
				<el-table-column type="index" align='center' width="60" label="序号"></el-table-column>
				<el-table-column prop="username" align='center' label="登录用户名"></el-table-column>
				<el-table-column prop="deptName" align='center' label="所属部门"></el-table-column>
				<el-table-column prop="nickname" align='center' label="昵称"></el-table-column>
				<!--<el-table-column prop="roleNames" align='center' label="角色名称"></el-table-column>-->
				<el-table-column prop="mobile" align='center' label="手机号"></el-table-column>
				<!-- <el-table-column prop="email" align='center' label="邮箱"></el-table-column> -->
				<el-table-column prop="" align='center' label="状态">
					<template slot-scope="scope">
						<span v-if="scope.row.status === 1">正常</span>
						<span v-else>无效</span>
					</template>
				</el-table-column>
        <el-table-column prop="loginCount" align='center' label="登录次数"></el-table-column>
        <el-table-column prop="lastLoginTime" align='center' label="最近登录时间"></el-table-column>
				<!-- <el-table-column prop="sex == 1?'男':'女'" align='center' label="性别">
					<template slot-scope="scope">
						<span v-if="scope.row.sex === 1">男</span>
						<span v-else>女</span>
					</template>
				</el-table-column> -->
				<el-table-column prop="" width="100" label="操作" align="center">
					<template slot-scope="scope">
						<el-button type="success" icon="el-icon-edit" circle @click="edit(scope.row,scope.$index)" class="btnmargin"></el-button>
						<!--<el-tooltip class="item" effect="dark" content="重置密码" placement="top-start">
							<el-button type="warning" icon="el-icon-refresh" circle @click="Reset(scope.row,scope.$index)" class="btnmargin"></el-button>
						</el-tooltip>-->
						<el-button type="warning" icon="el-icon-delete" circle @click="deletes(scope.row,scope.$index)" class="btnmargin"></el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="fye">
			<pagintion @dsydata='DsyData' @dstdata="DstData" :total='total' :pageNums="pageNums"></pagintion>
		</div>

		<userpopup v-if="dialogVisible == true" :mystate="Addsid" @getcancel="Getcancel" @adddata="Adddata"></userpopup>
	</div>
</template>
<script>
	import pagintion from '@/components/mangement/pagintion.vue';

	import userpopup from "./popup/userpopup.vue";
	import {userlist,userdelete, passwordReset,logouts,} from "@/api/api";
	export default {
		data() {
			return {
				tabledata: [],
				tableHeight: window.innerHeight - 180,
				total: 0,
				pageSize: 20, //每页多少条数据分页
				pageNum: 0, //当前页
				pageNums: null,
				username:'',
				dw:'',
				dialogVisible:false,
				Addsid:[],
				sjcdid:'',
				sjcd:'',
				datatree: [],
				defaultProps: { /// tree设置
					children: 'children',
					label: 'name'
				},
				khdwshow: false,
				treesid: '',
        multipleSelection: [],
			}
		},
		components: {
			pagintion,
			userpopup
		},
		mounted() {
			let params={
				pageSize: this.pageSize,
				pageNum: this.pageNum,
			}
			this.list(params)
		},
		methods: {
			handleNodeClick(data, e) {
				this.sjcdid = data.id;
				this.sjcd = data.name;
			},
			focusval(e) {
				this.khdwshow = true
			},
			blurval1(e) {
				let _this = this
				setTimeout(function() {
					_this.khdwshow = false
				}, 200)
			},
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },

			query(){
        this.pageSize = 20;
        this.pageNum = 0;
				let params={
					pageSize: this.pageSize,
					pageNum: this.pageNum,
					username:this.username,
					//deptName:this.sjcd
				}
				this.list(params)
			},
			resets(){
        console.log(this.multipleSelection)
        let _this = this;
        if (this.multipleSelection.length == 0) {
          this.$notify({
            title: "提示",
            message: "请选择要重置密码的数据！",
            type: "warning",
          });
        } else {
          this.$confirm('此操作将重置选中用户的登录密码, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(action => {
            if (action === 'confirm') {
              let ids = [];
              for (let i = 0; i < this.multipleSelection.length; i++) {
                ids.push(this.multipleSelection[i].id);
              }
              passwordReset(ids).then((res) => {
                if(res.code == 200){

                  _this.$notify({
                  title: "提示",
                  message: '密码重置成功!',
                  type: "success",
                });

                //自动登出
              let params1 = {};
              this.$router.replace("siginIn");
              logouts(params1).then((res) => {
                if (res.code == 200) {
                  window.localStorage.clear();
                  this.$store.commit("toKen", null);
                  this.$store.commit("userId", null);
                  this.$store.commit("naMe", null);
                  this.$store.commit("unIt", null);
                  this.$store.commit("Tel", null);
                  this.$router.replace("siginIn");
                }
              });

                }

              });
            }
          }).catch(() => {
          });
        }
				// let params={
				// 	pageSize: this.pageSize,
				// 	pageNum: this.pageNum,
				// }
				// this.list(params)
			},
			list(params){
				userlist(params).then((res)=>{
					this.total = res.total;
					this.tabledata = res.data;
				})

			},
			addClick(){
				this.Addsid = ['xz']

				this.dialogVisible = true;
			},
			Getcancel(data) {
				this.dialogVisible = data.dialogVisible;

			},
			Adddata(data) {
				this.dialogVisible = data.dialogVisible;
				let params={
					pageSize: this.pageSize,
					pageNum: this.pageNum,
				}
				this.list(params)

			},
			DsyData(data) { //多少页
				this.pageNum = data.dsy;
				let params = {
					pageSize: this.pageSize,
					pageNum: this.pageNum,
					username:this.username,
				}
				this.list(params)
			},
			DstData(data) { //多少条
				this.pageSize = data.dst;
				let params = {
					pageSize: this.pageSize,
					pageNum: this.pageNum,
					username:this.username,
				}
				this.list(params)
			},
			edit(row, i) { //修改
				this.dialogVisible = true;
				this.Addsid = ['bj', row]
			},
			Reset(row, i) {
				this.$confirm('此操作将会重置您的密码,重置后新密码为123456, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(action => {
					if(action === 'confirm') {
						let params = {
							id: row.id
						};
						Resetpassword(params, this.tokens).then((res) => {
							if(res.code == 200) {
								this.$message1(res.message, 'success');
							} else {
								this.$message.error(res.message);
							}
						})
					}
				}).catch(() => {

					this.$message({
						message: '已取消',
						type: 'warning'
					});
				});
			},
			deletes(row, index) {
				this.$confirm('确定删除当前用户吗?此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(action => {
					if(action === 'confirm') {

						let params = {};
						userdelete({id:row.id}).then((res) => {
							if(res.code == 200) {
								this.$notify({
									title: "提示",
									message: res.message,
									type: "success",
								});
								let params = {
									pageSize: this.pageSize,
									pageNum: this.pageNum,

								}
								this.list(params)

							} else {
								this.$notify({
									title: "提示",
									message: res.message,
									type: "success",
								});
							}

						})
					}
				}).catch(() => {

					this.$message({
						message: '已取消',
						type: 'warning'
					});
				});
			},
		}
	}
</script>

<style scoped>
	@import url('../../common/css/mangementall.css');
	.querys {
		height: 30px;
		float: right;
		width: 200px;
		margin-top: 10px;
		margin-right: 10px;
	}

	>>>.el-input__inner {
		height: 30px;
		line-height: 30px;
		color: #606266;

		font-size: 14px;
	}
</style>
